<div class="header">
    <div class="header-left">
        <a class="back" routerLink=".." data-test="dialog-create-quiz-back">
            <i class="pi pi-arrow-left"></i>
        </a>
        <h2>{{ 'modules.items.dialog.createQuiz.title' | translate }}</h2>
    </div>
    <button class="close" type="button" [attr.aria-label]="'common.close' | translate" data-test="dialog-create-quiz-close" (click)="close()">
        <i class="pi pi-times"></i>
    </button>
</div>

<form [formGroup]="form" (ngSubmit)="onSubmit()" class="body" autocomplete="off">
    <div class="section">
        <h2>{{ 'quizzes.fieldset.basic' | translate }}</h2>
        <app-form-input
            [control]="form.controls.name"
            [label]="'quizzes.form.name' | translate"
            [placeholder]="'quizzes.form.name.placeholder' | translate"
            inputId="name"
            testId="dialog-create-quiz-name"
        />
    </div>
</form>

<div class="footer">
    <a pButton [outlined]="true" severity="secondary" data-test="dialog-create-quiz-cancel" routerLink="..">
        <span pButtonLabel>{{ 'modules.form.cancel' | translate }}</span>
    </a>
    <p-button
        type="submit"
        [label]="'modules.items.dialog.create.submit' | translate"
        [loading]="saving()"
        [disabled]="form.disabled"
        data-test="dialog-create-quiz-submit"
        (onClick)="onSubmit()"
    />
</div>
